/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { entityService } from './services';

const pathname = '/entity-lark-bases';

export const EntityLarkBaseApi = {
  initDiscountLarkSheet: async (id: string) => {
    const url = `${pathname}/init-entity-lark-base-for-discount/${id}`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  initStockLarkSheet: async (id: string) => {
    const url = `${pathname}/init-entity-lark-base-for-stock/${id}`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  filter: async (options: FilterEntityLarkBasesOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(options);
    url += query;

    try {
      return await entityService.post(url);
    } catch (error) {
      throw error;
    }
  },

  filterDiscount: async (options: FilterEntityLarkBasesOptions) => {
    let url = `${pathname}/filter/discount`;
    const query = serialize(options);
    url += query;

    try {
      return await entityService.post(url);
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneForDiscount: async (id: string) => {
    const url = `${pathname}/${id}/discount`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createForDiscount: async (body: any) => {
    const url = `${pathname}/discount`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateForDiscount: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/discount`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkConnect: async body => {
    const url = `${pathname}/check-connection`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FilterEntityLarkBasesOptions {
  page?: number;
  take?: number;
  order?: any;
  reserved?: boolean;
  name?: string;
  entityID?: string;
  status?: number;
}
